'use client';

import { useRouter } from 'next/navigation';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { getAssetTradeUrl } from '../../../route-builders';
import { useModalDrawerContext } from '../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { useIsBelowScreenWidth } from '../../../layouts/utils/useIsBelowScreenWidth';
import { OrderTypeDrawer } from '../OrderTypeDrawer/OrderTypeDrawer';
import { ButtonBase } from '../../../common/components';
import { ButtonComponentProps } from '@bts-web/core-features/common';

const NewOrderButton = ({
  assetId,
  children,
  visual = 'primary',
  size = 'large',
  withBorderRadius,
  fullWidth,
  className,
}: {
  assetId: string;
  children?: React.ReactNode;
  visual?: ButtonComponentProps['visual'];
  size?: ButtonComponentProps['size'];
  withBorderRadius?: ButtonComponentProps['withBorderRadius'];
  fullWidth?: ButtonComponentProps['fullWidth'];
  className?: string;
}) => {
  const { t } = useClientTranslation();

  const { openDrawer, close } = useModalDrawerContext();

  const router = useRouter();

  const isMobile = useIsBelowScreenWidth(1024);

  const onClickButton = () => {
    openDrawer(OrderTypeDrawer, {
      title: t('stop_order_title_@tenant'),
      position: isMobile ? 'bottom' : 'right',
      onChangeOrderType: (orderType) => {
        const redirectUrl = getAssetTradeUrl(assetId, {
          type: 'orderForm',
          orderType,
        });

        router.push(redirectUrl);

        close();
      },
    });
  };

  return (
    <ButtonBase
      size={size}
      visual={visual}
      withBorderRadius={withBorderRadius}
      className={className}
      onClick={onClickButton}
      fullWidth={fullWidth}
    >
      {children ? children : t('stop_order_order_create_new_order')}
    </ButtonBase>
  );
};

export { NewOrderButton };
